const displaySubmissionLink = (
  isVirtual: boolean,
  isVirtualOpen = false,
  onlyAllowRunkeeperResultSubmission = false
): boolean => isVirtual || (isVirtualOpen && !onlyAllowRunkeeperResultSubmission);

export default displaySubmissionLink;
